import { FaRegUserCircle } from "react-icons/fa";
import "../styles/general.css";
import "../styles/queries.css";
import "../styles/Login.css";
import { useData } from "../providers/ContextProvider";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

function Login() {
  const [userCredentials, setUserCredentials] = useState({
    userName: "",
    password: "",
  });

  const [error, setError] = useState("");

  const { dispatch } = useData();
  // const { state } = useLocation();
  const navigate = useNavigate();
  // const path = state?.path;

  const setCredentials = (e) => {
    let newUserCredentials = {
      ...userCredentials,
      [e.target.name]: e.target.value,
    };
    setUserCredentials(newUserCredentials);
  };

  const resetForm = () => {
    setUserCredentials({
      userName: "",
      password: "",
    });
  };

  const loginWithCredentials = async (e, dispatch) => {
    e.preventDefault();
    const result = await axios
      .post("http://localhost:5000/login", userCredentials)
      .catch((error) => {
        const errorMessage = error?.response?.data?.errorMessage;
        setError(errorMessage);
        resetForm();
      });
    if (result.data?.success) {
      const userID = result.data.user;
      const token = result.data.token;
      const goals = await axios.get(`http://localhost:5000/goals/${userID}`, {
        headers: { token },
      });
      console.log({ goals });
      const scores = await axios.get(`http://localhost:5000/scores/${userID}`, {
        headers: { token },
      });
      console.log({ scores });
      if (goals?.data?.success && scores?.data?.success) {
        dispatch({
          type: "LOGIN",
          payload: {
            userID,
            scores: scores.data.scores,
            goals: goals.data.goals,
            token,
          },
        });
        goals.data.goals.length === 0
          ? navigate("/app/set-goals")
          : navigate("/app/add-score");
      }
    }
  };

  return (
    <main className="main">
      <div className="form-container login-form-container">
        <h3 className="tertiary-heading form-heading">
          <FaRegUserCircle />
          Login
        </h3>
        <div className="divider"></div>
        <form
          className="form login-form"
          onSubmit={(e) => loginWithCredentials(e, dispatch)}
        >
          <div>
            <label htmlFor="username">Username</label>
            <input
              id="userName"
              type="text"
              value={userCredentials.userName}
              name="userName"
              placeholder="Akshita Saini"
              required
              onChange={(e) => setCredentials(e)}
            ></input>
          </div>
          <div>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={userCredentials.password}
              name="password"
              placeholder="********"
              required
              onChange={(e) => setCredentials(e)}
            ></input>
          </div>
          {error ? <div className="errorMessage">{error}</div> : ""}
          <button type="submit" className="btn btn-fill">
            Login
          </button>
          <div className="login-footer">
            Don't have an account?{" "}
            <Link to="/sign-up" className="login-footer-link">
              Sign Up{" "}
            </Link>{" "}
            now!
          </div>
        </form>
      </div>
    </main>
  );
}

export default Login;
